import React from 'react';
import { Spinner, Tooltip } from 'design-system';
import { useObjectPreview } from 'corp/hooks/smartId/useObjectPreview';
import { INamedObjectTypes, IProjectCollectionPreviewJson } from '@scale/shared/types/lookup';
import IsomorphicLink from 'corp/components/UI/IsomorphicLink';
import moment from 'moment';

const ProjectCollectionPreview: React.FC<{ id: string }> = ({ id }) => {
  const {
    value: projectCollection,
    loading,
    error,
  } = useObjectPreview<IProjectCollectionPreviewJson>(id, INamedObjectTypes.ProjectCollection);
  if (error) return <span>Sorry, there was an error</span>;
  if (loading) return <Spinner />;

  return (
    <div className="project-preview">
      <style jsx>{`
        .project-preview__banner {
          font-weight: bold;
          padding: 10px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: flex-start;
        }
        .project-preview__thing-list > div {
          display: flex;
        }
        .project-preview__thing-list strong {
          color: #666;
          margin-right: 10px;
          min-width: 120px;
          text-align: right;
        }
      `}</style>
      <div className="project-preview__banner">
        <h3 style={{ margin: '0 5px' }}>{projectCollection?.name}</h3>
      </div>
      <div className="project-preview__body">
        <div className="project-preview__thing-list">
          <div>
            <strong>Project Collection</strong>
            <IsomorphicLink
              target="_blank"
              rel="noopener noreferrer"
              href={`/project_collection/${id}`}
            >
              {id}{' '}
            </IsomorphicLink>
          </div>
          {projectCollection && !!projectCollection.createdAt && (
            <div>
              <strong>Created</strong>
              <Tooltip
                placement={'top'}
                title={new Date(projectCollection.createdAt).toLocaleString()}
              >
                <span>{moment(projectCollection.createdAt).fromNow()}</span>
              </Tooltip>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectCollectionPreview;
